import React, { useContext, Fragment, useEffect, useState } from 'react'
import operatorContext from '../../../context/operator/operatorContext'
import { useAlert } from "react-alert";
import { Button, Modal } from 'react-bootstrap'

const OperatorPendingJobItem = ({ pendingJob }) => {

    const OperatorContext = useContext(operatorContext);


    const { rejectNewJob, acceptNewJob, clearAlert, operator, getRejectionList } = OperatorContext;

    const { id ,farm, farmer_equipment_request, status } = pendingJob;

    const { farm_name, address } = farm;

    const { start_time, end_time } = farmer_equipment_request;

    const alert = useAlert()

    const [show, setShow] = useState(false);

    const [reason, setReason] = useState("");

    const handleClose = () => setShow(false);

    
    const handleShow = () => {
        setShow(true);
        getRejectionList();
    }

    useEffect(() => {

        if (operator.message.msg !== "") {
            alert.show(
                operator.message.msg, operator.message.msg_options
            )
            clearAlert()
        }
        //eslint-disable-next-line
    }, []);

    //Accept new job
    const onAccept = new_job_id => {
        acceptNewJob(new_job_id)
    }

    //Decline new job
    const onDecline = new_job_id => {
        rejectNewJob(new_job_id)
    }

    //Reject Job
    const handleSubmit = () => {

        var data = { id, reason}
        rejectNewJob(data)
        handleClose()
    }

    return (
        <Fragment>
        
        <td>{farm_name}</td>
        <td>{address}</td>
        <td>{start_time}</td>
        <td>{end_time}</td>
        <td>
            {status === 0 ? "AVAILABLE" : status === 1 ? "ENGAGED" : "REJECTED"}
        </td>
        <td className="button-container">
            <button type="button" onClick={() => onAccept(id)}
                    className="btn button_style btn-inverse-success mr-3 waves-effect waves-light">ACCEPT
            </button>
        </td>
        <td>
            <button type="button" onClick={handleShow}
                    className="btn button_style btn-inverse-danger waves-effect waves-light">DECLINE
            </button>
        </td>

        <form id="rejection-form" onSubmit={handleSubmit}>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Reason for declining job</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <input type="hidden" value={id} name="id" />
                    <div className="form-group">
                        <select name="job_rejection_reason_id" className="form-control" id="" onChange={(e) => setReason(e.target.value)}>
                            {
                                operator.rejectionList.length > 0 ? operator.rejectionList.map((rl) => (
                                    <option key={rl.id} value={rl.id} >
                                        {rl.reason}
                                    </option>
                                )) : <option>Select Reason.</option>
                            }
                        </select>
                    </div>
                
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button  type="submit" variant="primary" onClick={handleSubmit}>
                    DECLINE JOB
                </Button>
                
                </Modal.Footer>
            </Modal>
        </form>


    </Fragment>
    )
}

export default OperatorPendingJobItem
